import { PermissionsScope } from '../../policies/policy.model'

export const ROLE_SCOPE: PermissionsScope = 'iam'
export const ROLE_FRAGMENT = 'role'
